import { SecurityDomainError } from './problems';

export function normalizeIpAddress(value: string): string {
  if (typeof value !== 'string') {
    throw new SecurityDomainError('invalidIp', 422);
  }
  if (value.includes(':')) {
    return normalizeIpv6(value);
  }
  const parts = value.trim().split('/');
  const octets = parts[0].split('.');
  if (
    parts.length > 2 ||
    (parts[1] !== undefined && !/^(?:[0-9]|[12][0-9]|3[0-2])$/.test(parts[1])) ||
    octets.length !== 4 ||
    octets.some((part) => !/^(0|[1-9]\d{0,2})$/.test(part) || Number(part) > 255)
  ) {
    throw new SecurityDomainError('invalidIp', 422);
  }
  const prefix = parts[1] === undefined ? 32 : Number(parts[1]);
  if (prefix === 32) {
    return octets.join('.');
  }
  const numeric = octets.reduce((address, octet) => address * 256 + Number(octet), 0);
  const network = Math.floor(numeric / 2 ** (32 - prefix)) * 2 ** (32 - prefix);
  return `${[24, 16, 8, 0].map((shift) => (network >>> shift) & 255).join('.')}/${prefix}`;
}
function normalizeIpv6(value: string) {
  const parts = value.trim().split('/');
  if (
    parts.length > 2 ||
    !/^[\da-f:]+$/i.test(parts[0]) ||
    (parts[1] !== undefined && !/^(?:0|[1-9]\d{0,2})$/.test(parts[1]))
  ) {
    throw new SecurityDomainError('invalidIp', 422);
  }
  let normalized: string;
  try {
    normalized = new URL(`http://[${parts[0]}]/`).hostname.slice(1, -1);
  } catch {
    throw new SecurityDomainError('invalidIp', 422);
  }
  const prefix = parts[1] === undefined ? 128 : Number(parts[1]);
  if (prefix > 128) {
    throw new SecurityDomainError('invalidIp', 422);
  }
  const halves = normalized.split('::');
  const left = halves[0] ? halves[0].split(':') : [];
  const right = halves[1] ? halves[1].split(':') : [];
  const words =
    halves.length === 1
      ? left
      : [...left, ...Array(8 - left.length - right.length).fill('0'), ...right];
  let numeric = words.reduce((acc, word) => (acc << 16n) + BigInt(`0x${word}`), 0n);
  const shift = BigInt(128 - prefix);
  numeric = (numeric >> shift) << shift;
  const full = Array.from({ length: 8 }, (_, index) =>
    Number((numeric >> BigInt((7 - index) * 16)) & 65535n).toString(16),
  ).join(':');
  const network = new URL(`http://[${full}]/`).hostname.slice(1, -1);
  return prefix === 128 ? network : `${network}/${prefix}`;
}
